<template>
  <div class="accommodation">
    <h1>Ubytování</h1>
    <span class="overview">Přehled nabízeného ubytování s kapacitami a cenami najdete <a target="_blank" href="https://docs.google.com/document/d/1n6S7fpr6OSya595Lk_GaT0GMnQPzD14PiUNYjukW54M/edit?pli=1#heading=h.ywndulo8a7k4">zde</a></span>
    <a
      class="exchange"
      href="https://docs.google.com/spreadsheets/d/1Gh6jy6tDk-Kcx_cyCwYnMiDZY_k4x2TaXYgt2JzHdGU/edit?usp=sharing"
      target="_blank"
    >
      <i class="fas fa-exchange-alt"></i> Burza kvót ubytování
    </a>
    <div class="quote">
      <div class="start">
        {{ quote_start_label }}
        <span class="data">{{ outpost.accommodationState.nextStepAt | cz }}</span>
      </div>
      <div class="count">
        {{ quote_amount_label }}
        <span class="data">{{ quote_amount }}</span>
      </div>
    </div>
    <div
      v-if="outpost.accommodationState.status == 1 || outpost.accommodationState.status == 2"
      class="send"
    >
      <input
        type="number"
        min="0"
        :max="outpost.accommodationState.quote - quote_used"
        v-model="sendAmount"
      />
      <dropdown :items="outposts" @change="change">
        <template v-slot:label>{{ sendLabel }}</template>
        <template v-slot:item="props">{{ props.id }}.PH - {{ props.item }}</template>
      </dropdown>
      <button @click="send">Poslat kvótu</button>
    </div>
    <img id="map_background" src="map.jpg" alt="mapa" />
    <mapSchema @addAcc="addAcc" @removeAcc="removeAcc" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { _ } from "../extend";
import { data } from "../store_utils";
import mapSchema from "../components/map_schema";
import dropdown from "../components/dropdown";

export default {
  name: "accommodation",
  components: {
    mapSchema,
    dropdown
  },
  computed: {
    ...mapState(["accommodation", "outpost", "outposts"]),
    quote_start_label() {
      switch (this.outpost.accommodationState.status) {
        case 0:
          return "Kvóta bude zafixována: ";
        case 1:
          return "Prodej ubytování podle kvót začne: ";
        case 2:
          return "Prodej ubytování bez kvót začne: ";
        case 3:
          return "Poslední možnost odhlašování ubytování: ";
        case 4:
          return "";
        default:
          return "!Chyba!";
      }
    },
    quote_amount_label() {
      switch (this.outpost.accommodationState.status) {
        case 0:
          return "Vaše předběžná kvóta: ";
        case 1:
          return "Vaše kvóta: ";
        case 2:
          return "Vaše volná kvóta: ";
        case 3:
        case 4:
          return "Kvóty už nejsou aktivní";
        default:
          return "!Chyba!";
      }
    },
    quote_amount() {
      switch (this.outpost.accommodationState.status) {
        case 0:
        case 1:
          return this.outpost.accommodationState.quote;
        case 2:
          return `${this.outpost.accommodationState.quote -
            this.quote_used} / ${this.outpost.accommodationState.quote || 0}`;
        case 3:
        case 4:
          return null;
        default:
          return "!Chyba!";
      }
    },
    quote_used() {
      return _.sum(this.$store.getters.myAccommodation, acc => acc.amount);
    },
    sendLabel() {
      if (this.sendToOutpostId == null) return "Vyberte hlídku";

      return `${this.sendToOutpostId}.PH - ${
        this.outposts[this.sendToOutpostId]
      }`;
    }
  },
  data: () => ({
    sendAmount: 0,
    sendToOutpostId: null
  }),
  methods: {
    addAcc(event) {
      if (this.outpost.accommodationState.status <= 1) {
        this.$store.commit("notify", {
          text: "Registrace ubytování ještě není spuštěna",
          level: "warning"
        });
        return;
      }

      if (this.outpost.accommodationState.status == 2) {
        // check
        if (
          this.quote_used + this.accommodation[event.id].amount >
          this.outpost.accommodationState.quote
        ) {
          this.$store.commit("notify", {
            text: "Nemáte dostatečnou kvótu",
            level: "warning"
          });
          return;
        }
      }

      this.$store.dispatch("tryOrderAccommodation", {
        accommodationId: event.id
      });
    },
    removeAcc(event) {
      if (this.outpost.accommodationState.status == 4 && !this.$store.getters.isChangedAt(["accommodation", event.id, "outpostId"])) {
        this.$store.commit("notify", {
          text: "Již nelze odhlašovat ubytování",
          level: "warning"
        });
        return;
      }

      this.$store.commit("update", {
        paths: ["accommodation", event.id, "outpostId"],
        value: null
      });
    },
    change(value, key) {
      this.sendToOutpostId = key;
    },
    send() {
      if (this.sendToOutpostId == null) {
        this.$store.commit("notify", {
          text: "Musíte vybrat hlídku",
          level: "warning"
        });
        return;
      }
      if (this.sendAmount <= 0) {
        this.$store.commit("notify", {
          text: "Nelze poslat záporné nebo žádné množství",
          level: "warning"
        });
        return;
      }
      if (
        this.sendAmount >
        this.outpost.accommodationState.quote - this.quote_used
      ) {
        this.$store.commit("notify", {
          text: "Nelze poslat více než máte",
          level: "warning"
        });
        return;
      }

      this.$store.commit("add", {
        paths: ["accommodationTransfers", data.newGuid()],
        value: {
          amount: parseInt(this.sendAmount),
          targetOutpostId: parseInt(this.sendToOutpostId)
        }
      });
      this.$store.commit("update", {
        paths: ["outpost", "accommodationState", "quote"],
        value: this.outpost.accommodationState.quote - this.sendAmount
      });
      this.sendAmount = 0;
      this.sendToOutpostId = null;
    }
  }
};
</script>

<style lang="sass">
@import ../sass/_constants
@import ../sass/_components

.accommodation
  display: grid
  margin:
    right: auto
    left: auto
  height: 100%
  width: $w-content
  align-items: center
  justify-items: center

  grid-template-areas: "label link" "overview link" "quote sender" "map map"
  grid-row-gap: 5px
  .data
    font-weight: bold

  h1
    grid-area: label
    justify-self: start
  .overview
    grid-area: overview
    justify-self: start
    a
      @include button-secondary()
  .exchange
    grid-area: link
    align-self: center
    justify-self: end
    @include button-secondary()
  .quote
    grid-area: quote
    justify-self: start
  .send
    grid-area: sender
    justify-self: end

    display: flex
    input
      @include input-base()
      @include first-input()
    .input-select .label
      @include middle-input()
    button
      @include button-primary()
      @include last-input()
  #map_background
    grid-area: map
  #map_schema
    grid-area: map
    g *
      cursor: pointer;
</style>
